// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 3H16.5V1H7.5V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 6V4H2V6H4.02898L4.52898 23H19.471L19.971 6H22ZM11 19V8H13V19H11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-delete-filled')
export default class DeleteFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'delete-filled',
    }
  }
}
